import React from 'react'
import AboutNavBar from '../components/AboutNavBar'
import Footer from '../components/Footer'
import RenderLinks from '../components/RenderLinks'
import Cart from '../components/Cart'

function Carts() {
  return (
    <div>
      {/* <RenderLinks/> */}
      <AboutNavBar/>
      <Cart/>
      <Footer/>
    </div>
  )
}

export default Carts
